import {inject, Injectable} from '@angular/core';
import {environment} from '../../../../environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {IProductList} from './product.model';

export type EntityArrayResponseType = HttpResponse<IProductList>;

@Injectable({
  providedIn: 'root'
})
export class ProductCatalogService {
  private apiProduct = `${environment.wsApiBaseUrl}/api/product`
  protected readonly http = inject(HttpClient);

  findByParams(params: any) {
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value === null || value === undefined || value === "" || value === "Todos") delete params[key];
    });

    return this.http.get<IProductList>(this.apiProduct, {observe: 'response', params })
  }

  findRelatedItemsByItemIds(params: any, customerAN?: number | string | null) {
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value === null || value === undefined || value === "" || value === "Todos") delete params[key];
    });

    if (customerAN !== undefined && customerAN !== null) {
      params['customerAN'] = String(customerAN);
    }

    return this.http.get<IProductList>(`${environment.wsApiBaseUrl}/api/item/related-items`, {observe: 'response', params })
  }
}
